export default __webpack_public_path__ + "static/media/201.72613d3c.jpg";